import { Routes } from '../../Routes';

export enum FlowType {
  PetCareBrowsing = 'petCareBrowsing',
  PetCareRecurring = 'petCareRecurring',
  OtherBrowsing = 'otherBrowsing',
  ChildCare = 'childCare',
  SeniorCare = 'seniorCare',
  HouseholdServices = 'householdServices',
}

export interface FlowSteps {
  [FlowType.ChildCare]: string[];
  [FlowType.PetCareRecurring]: string[];
  [FlowType.PetCareBrowsing]: string[];
  [FlowType.OtherBrowsing]: string[];
  [FlowType.SeniorCare]: string[];
  [FlowType.HouseholdServices]: string[];
}

export const flowSteps: FlowSteps = {
  [FlowType.ChildCare]: [
    Routes.parent.registration.vertical,
    Routes.parent.registration.frequency,
    Routes.parent.registration.location,
    Routes.parent.registration.great,
    Routes.parent.registration.selectDateTimes,
    Routes.parent.registration.fantastic,
    Routes.parent.registration.photo,
    Routes.parent.registration.count,
    Routes.parent.registration.profilePreview,
    Routes.parent.registration.includes,
    Routes.parent.registration.sweeteners,
    Routes.parent.registration.details,
    Routes.parent.registration.success
  ],
  [FlowType.SeniorCare]: [
    Routes.parent.registration.vertical,
    Routes.parent.registration.frequency,
    Routes.parent.registration.location,
    Routes.parent.registration.great,
    Routes.parent.registration.selectDateTimes,
    Routes.parent.registration.fantastic,
    Routes.parent.registration.photo,
    Routes.parent.registration.count,
    Routes.parent.registration.profilePreview,
    Routes.parent.registration.details,
    Routes.parent.registration.success
  ],
  [FlowType.HouseholdServices]: [
    Routes.parent.registration.vertical,
    Routes.parent.registration.frequency,
    Routes.parent.registration.location,
    Routes.parent.registration.great,
    Routes.parent.registration.selectDateTimes,
    Routes.parent.registration.fantastic,
    Routes.parent.registration.photo,
    Routes.parent.registration.profilePreview,
    Routes.parent.registration.details,
    Routes.parent.registration.success
  ],
  [FlowType.PetCareRecurring]: [
    Routes.parent.registration.vertical,
    Routes.parent.registration.petType,
    Routes.parent.registration.frequency,
    Routes.parent.registration.location,
    Routes.parent.registration.great,
    Routes.parent.registration.selectDateTimes,
    Routes.parent.registration.fantastic,
    Routes.parent.registration.photo,
    Routes.parent.registration.count,
    Routes.parent.registration.profilePreview,
    Routes.parent.registration.details,
    Routes.parent.registration.success
  ],
  [FlowType.PetCareBrowsing]: [
    Routes.parent.registration.vertical,
    Routes.parent.registration.petType,
    Routes.parent.registration.frequency,
    Routes.parent.registration.location,
    Routes.parent.registration.success
  ],
  [FlowType.OtherBrowsing]: [
    Routes.parent.registration.vertical,
    Routes.parent.registration.frequency,
    Routes.parent.registration.location,
    Routes.parent.registration.success
  ],
}
